/**
 * メルマガバックナンバーで利用
 */

//無限スクロール
function infinitescroll_action() {
	$(function () {
		$(".infinit").infinitescroll({
			navSelector: ".pagenavi",
			nextSelector: ".pagenavi .next",
			itemSelector: ".infinit-cont",
			loading: {
				msgText: '',
				finishedMsg: '',
			}
		});

		$('.infinit').infinitescroll('unbind');
		var c = 1;
		$("#more").on('click', function () {
			$('.infinit').infinitescroll('retrieve');
			c++;
			if (c == post_count) {
				$(this).remove();
			}
			return false;
		});
	});
}

//サイドバーの日付の表記を変更
function mailmagazine_side_archive() {
	$(function () {
		$('#sidebar .js-archive-list li').each(function () {
			var archive_date = moment($(this).text(), 'YYYY年MM月');
			archive_date = archive_date.format('YYYY/MM');
			$(this).children('a').text(archive_date);
			$(this).css('opacity', 1);
		});
	});
}


/**
 * 店舗詳細、店舗一覧、現在地からの店舗一覧で利用
 * 2018/12
 */

 //予約関連をモーダルで表示
function my_modal() {
	$(function(){
		//モーダル開く		
		$('.js-my-modal').on('click', function(){
			var target_id = '#' + $(this).data('modal-target');
			$(target_id).addClass('on');
			$(target_id).parents('#modal-bg').fadeIn('normal');
			$('#modal-contents .modal-close').show();
		});
		//閉じる
		$('#modal-contents .modal-close').on('click', function() {
			$(this).hide();
			$(this).parents('#modal-bg').fadeOut('normal');
			$(this).parent('#modal-contents').children('.on').removeClass('on');

			//immediately_formのチェックボックスによる非表示をリセット
			$('#sp-reserve-select ul').removeClass('btn1');
		});
	});
}
//店舗一覧のモーダル スマホの店舗一覧で利用
function shop_list_modal() {
	$(function(){
		var reserve_href = $('#sp-reserve-select .immediately a').attr('href');
		//idとslugを渡して予約のリンクで利用
		$('.js-loop-modal').on('click', function() {
			//即予約
			var immediately_url = $(this).data('post-url')
			if($(this).data('immediately-check') == 'on'){
				$('#sp-reserve-select .immediately a').attr('href', immediately_url);
			} else {
				$('#sp-reserve-select ul').addClass('btn1');
			}

			//リクエスト予約
			var post_name = $(this).data('post-slug')
			$('#sp-reserve-select .request a').attr('href', reserve_href + '/reserve/?shop_name=' + post_name);

			//GAトラッキングコード
			var post_title = $(this).data('post-title')
			var reserve_gtag = "gtag('event', 'click', {'event_category': '店舗一覧ページ','event_label': 'リクエスト予約ボタン " + post_title + "'});"
			$('#sp-reserve-select .request a').attr('onclick', reserve_gtag);

			var immediately_gtag = "gtag('event', 'click', {'event_category': '店舗一覧ページ','event_label': '即予約ボタン " + post_title + "'});"
			$('#sp-reserve-select .immediately a').attr('onclick', immediately_gtag);
		});
	});
}


//スマホのトップページ、フッター用バナー
function pc_home_footer_bnr() {
	var thisOffset;
	$(window).on('load', function () {
		thisOffset = $('#midContent section.bnr').offset().top;

		//バナーのfadeIn
		setTimeout(function () {
			$('.footer_bnr').addClass('on');
		}, 500);

		banner_position(thisOffset);
	});

	//スクロール時に実行
	$(window).scroll(function () {
		banner_position(thisOffset);
	});
}

//PCAIバナーのポジション設定
function banner_position(thisOffset) {
	var fotter_height = $('footer').outerHeight()
	var bnr_height = $('#main section.bnr').outerHeight()
	if ($(window).scrollTop() + $(window).height() < thisOffset) {
		var footer_bnr = {
			"position": "fixed",
			"bottom": 0,
			"z-index": 6000,
		}
		$('.footer_bnr').css(footer_bnr);
	} else {
		var footer_bnr = {
			"position": "absolute",
			"bottom": fotter_height + bnr_height,
			"z-index": 0,
		}
		$('.footer_bnr').css(footer_bnr);
	}
}

//スマホのトップページ、フッター用バナー
function sp_home_footer_bnr() {
	$(window).on('load', function () {
		var h = jQuery('.footer_bnr img').height();
		var copy_padding = parseInt(jQuery('footer .copy small').css('padding-bottom'));
		$('footer .copy').css('padding-bottom', h + copy_padding);

		//バナーのfadeIn
		setTimeout(function () {
			$('.footer_bnr').addClass('on');
		}, 2000);
	});
}

/**
 * MAX GOの詳細ページ
 * 2019/06,07
 
//アコーディオン
function max_go_shop_list() {
	$(function(){
		$('.maxgo-schedule-list-area').on('click', function(){
			$(this).next('.maxgo-schedule-list-shop').slideToggle();
		});
	});
}*/

